"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Commander Spellbook API
 * API for Commander Spellbook, the combo database engine for Magic: The Gathering
 *
 * The version of the OpenAPI document: 4.8.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BracketTagEnum = void 0;
exports.instanceOfBracketTagEnum = instanceOfBracketTagEnum;
exports.BracketTagEnumFromJSON = BracketTagEnumFromJSON;
exports.BracketTagEnumFromJSONTyped = BracketTagEnumFromJSONTyped;
exports.BracketTagEnumToJSON = BracketTagEnumToJSON;
exports.BracketTagEnumToJSONTyped = BracketTagEnumToJSONTyped;
/**
 * * `R` - Ruthless
 * * `S` - Spicy
 * * `P` - Powerful
 * * `O` - Oddball
 * * `PA` - Precon Appropriate
 * * `C` - Casual
 * @export
 * @enum {string}
 */
var BracketTagEnum;
(function (BracketTagEnum) {
    BracketTagEnum["R"] = "R";
    BracketTagEnum["S"] = "S";
    BracketTagEnum["P"] = "P";
    BracketTagEnum["O"] = "O";
    BracketTagEnum["Pa"] = "PA";
    BracketTagEnum["C"] = "C";
})(BracketTagEnum || (exports.BracketTagEnum = BracketTagEnum = {}));
function instanceOfBracketTagEnum(value) {
    for (const key in BracketTagEnum) {
        if (Object.prototype.hasOwnProperty.call(BracketTagEnum, key)) {
            if (BracketTagEnum[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function BracketTagEnumFromJSON(json) {
    return BracketTagEnumFromJSONTyped(json, false);
}
function BracketTagEnumFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function BracketTagEnumToJSON(value) {
    return value;
}
function BracketTagEnumToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=bracketTagEnum.js.map